import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../../services/general.service';
// import { Personal } from '../models/personal';
// import {Familiar} from '../models/familiar';
import { MatPaginator,MatDialog, MatSort } from '@angular/material';
import { DataService } from '../../utils/data.service';
import { UbicacionAddEditComponent } from './agregar-editar/ubicacion-addedit.component';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
@Component({
  selector: 'my-ubicacion',
  styleUrls: [],
  templateUrl: 'ubicacion.component.html',
  providers: [generalService]
})


export class UbicacionComponent implements OnInit {
displayedColumns = ['acciones', 'nombre', 'contacto' , 'correo', 'telefono', 'direccion'];
dataSource: DataSourceGrid | null;
public datosUbicacion: Array<any>;
customer_id: string;

 @ViewChild(MatPaginator) paginator: MatPaginator;
 @ViewChild(MatSort) sort: MatSort;

   constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _generalService: generalService,
    public dataService: DataService,
    public dialog: MatDialog
    ) {
    this.customer_id = (this.route.snapshot.paramMap.get('id'));
    this.datosUbicacion = new Array();
  }

  ngOnInit() {
    this.getBitacora(this.customer_id);
  }

  getBitacora(id: any) {
    this._generalService.metodoCall(`ubicacion/consultarUbicaciones/${id}`).subscribe(
      (result) => {
        this.datosUbicacion = JSON.parse(result);
        this.dataSource = new DataSourceGrid(this.datosUbicacion, this.paginator, this.sort);
        if (this.datosUbicacion.length <= 0) {
            $('#tableUbicacion .mat-row').remove('.mat-row');
          }
      },
      (error) => {
        let errorMsj =  error as any;
        console.log(errorMsj);
      }
    );
  }

  agregar() {
    this.dataService.isUpdate = false;
    const dialogRef = this.dialog.open(UbicacionAddEditComponent, {disableClose: true});
    this.dataService.idCliente = this.customer_id;
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {

       this.ngOnInit();
    });
  }

  editar(idUbicacion) {
    this.dataService.id = idUbicacion;
    this.dataService.isUpdate = true;
    this.dataService.idCliente = this.customer_id;
    const dialogRef = this.dialog.open(UbicacionAddEditComponent, {disableClose: true});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {


      this.ngOnInit();
    });
  }

  eliminarConfirm(data: any) {
    const eliminarHttp = new EventEmitter<any>();
    eliminarHttp.subscribe(
      (response: any) => {

          this._generalService.toastCall('El registro se eliminó exitosamente!');
          this.ngOnInit();

      }
    );
    const ubicacion: any = new Object();
    ubicacion.idUbicacion = data.idUbicacion;
    this._generalService.modal(eliminarHttp, 'confirm', '¿Desea eliminar el registro ' + data.nombreUbicacion + '?', 'ubicacion/eliminarUbicacion/', ubicacion);
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/ubicacion/ubicacion.component.ts